<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <div class="col-span-12 lg:col-span-10">
            <vx-alert v-if="recentlyCreated" color="success" :closeable="false" class="mb-6" shadow>
                <template v-slot:icon>
                    <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                </template>
                <div class="flex items-center justify-between">
                    <span
                        ><strong>{{ orgUnit.name }}</strong> created successfully. Add users below.</span
                    >
                    <vx-button :href="`/settings/teams/${teamId}#/org-units`" size="sm" color="success"
                        >Back to OUs
                        <font-awesome-icon widthAuto :icon="faSquareArrowUpLeft"></font-awesome-icon>
                    </vx-button>
                </div>
            </vx-alert>
            <org-unit-user-list
                :orgUnitId="props.orgUnitId"
                :orgUnitName="orgUnit.name"
                :teamId="teamId"
            ></org-unit-user-list>
        </div>
    </org-unit-details>
</template>

<script setup>
import OrgUnitDetails from '~/components/settings/teams/org-units/form/OrgUnitDetails.vue';
import OrgUnitUserList from '~/components/settings/teams/org-units/form/users/OrgUnitUserList.vue';
import { VxAlert, VxButton } from '@voxie/frontend-components';
import { computed } from 'vue';
import dayjs from 'dayjs';
import { useOrgUnitDetails } from '../useOrgUnitDetails';
import { faCircleCheck, faSquareArrowUpLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const teamId = Spark.state.currentTeam.id;
const { orgUnit } = useOrgUnitDetails();

const props = defineProps({
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const recentlyCreated = computed(() =>
    orgUnit.value.created_at ? dayjs.utc(orgUnit.value.created_at).isAfter(dayjs().subtract(15, 'seconds')) : false
);
</script>
